import { render, staticRenderFns } from "./cutdetletop.vue?vue&type=template&id=29d4ad33&scoped=true&"
import script from "./cutdetletop.vue?vue&type=script&lang=js&"
export * from "./cutdetletop.vue?vue&type=script&lang=js&"
import style0 from "./cutdetletop.vue?vue&type=style&index=0&id=29d4ad33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4ad33",
  null
  
)

export default component.exports